import React, { ReactNode, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@mui/material";
import { WithLoadingSpinner } from "@rentablo/components";
import { useChartOptions } from "./useChartOptions";

type Props = {
  percentage: number;
  isFetching?: boolean;
  noDataMessage?: ReactNode;
  height?: number;
  width?: number;
  handlerCircle?: {
    radiusOffset: number;
    centerDistanceOffset: number;
  };
  centerPanel: {
    color: string;
    title: string;
    subtitle: string;
    icon: React.ReactNode;
  };
};

// @ts-ignore
Highcharts.seriesTypes.area.prototype.getPointSpline =
  // @ts-ignore
  Highcharts.seriesTypes.spline.prototype.getPointSpline;

HighchartsMore(Highcharts);

export const GaugeChart = ({
  percentage,
  isFetching,
  height = 200,
  width = 200,
  handlerCircle = { radiusOffset: 0.7, centerDistanceOffset: 0.95 },
  centerPanel,
}: Props) => {
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
  const chartOptions = useChartOptions(
    height,
    width,
    percentage,
    centerPanel,
    handlerCircle
  );

  useEffect(() => {
    chartComponentRef.current?.chart?.reflow();
  }, [chartOptions]);

  return (
    <Box pb={1}>
      <WithLoadingSpinner isLoading={Boolean(isFetching)}>
        <HighchartsReact
          highcharts={Highcharts}
          options={chartOptions}
          ref={chartComponentRef}
        />
      </WithLoadingSpinner>
    </Box>
  );
};
